export default {
  methods: {
    /**
     * Wait for all images inside this component to load,
     * then emit content-ready to hide the loader.
     */
    waitForImages() {
      this.$nextTick(() => {
        const images = this.$el.querySelectorAll("img");
        if (images.length === 0) {
          this.$emitContentReady();
          return;
        }

        let loaded = 0;
        images.forEach((img) => {
          if (img.complete) {
            loaded++;
          } else {
            img.onload = img.onerror = () => {
              loaded++;
              if (loaded === images.length) {
                this.$emitContentReady();
              }
            };
          }
        });

        if (loaded === images.length) {
          this.$emitContentReady();
        }
      });
    },
  },
};
